import { IDmNhomLoaiThuChi } from "../../../model/respone/category/IDmNhomLoaiThuChi";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDmNhomLoaiThuChiActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IDmNhomLoaiThuChi[],
  LOAD_ERRR: "",

  SAVE_START: {} as IDmNhomLoaiThuChi,
  SAVE_SUCCESS: {} as IDmNhomLoaiThuChi,
  SAVE_ERROR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERROR: "",

  SHOW_EDIT_MODAL: {} as undefined | IDmNhomLoaiThuChi,
  CLOSE_EDIT_MODAL: undefined,
};
export const eDmNhomLoaiThuChiActionIds = generateActionTypeIds(
  eDmNhomLoaiThuChiActionsObj,
  "NHOM_LOAI_THU_CHI"
);

export type IDmNhomLoaiThuChiActionTypes = IGenericActionType<
  typeof eDmNhomLoaiThuChiActionsObj,
  "NHOM_LOAI_THU_CHI"
>;
